module.exports = __webpack_public_path__ + "QuickBooks-logo.png?cea20b4d71d243a5d7e417ea79425201";